export enum EsitoEnum {
  OK = 'OK',
  KO = 'KO',
  NUMBER_0 = '0',
  NUMBER_1 = '-1',
}
